import React, { useState, useEffect } from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import Footer from '../Materials/Footer';


const ComingSoon = () => {
  const [clickCount, setClickCount] = useState(0);
  const [showGame, setShowGame] = useState(false);
  const [score, setScore] = useState(0);
  const [emojiPosition, setEmojiPosition] = useState({ x: 50, y: 50 });
  const [timeLeft, setTimeLeft] = useState(10);

  const handleMainTextClick = () => {
    const newCount = clickCount + 1;
    setClickCount(newCount);
    
    if (newCount === 5) {
      setShowGame(true);
      setClickCount(0);
      setTimeLeft(10);
      setScore(0);
      moveEmoji();
    }
  };

  const moveEmoji = () => {
    setEmojiPosition({
      x: Math.random() * 80,
      y: Math.random() * 80
    });
  };

  const handleEmojiClick = () => {
    setScore(score + 1);
    moveEmoji();
  };

  useEffect(() => {
    let timer;
    if (showGame && timeLeft > 0) {
      timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
    } else if (timeLeft === 0) {
      setShowGame(false);
    }
    return () => clearTimeout(timer);
  }, [showGame, timeLeft]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
  
      
      <Container maxWidth="lg" sx={{ 
        flexGrow: 1, 
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        position: 'relative'
      }}>
        {!showGame ? (
          <Box 
            sx={{ 
              p: 6,
              borderRadius: 2,
              backgroundColor: 'background.paper',
              boxShadow: 3,
              maxWidth: '600px',
              cursor: 'pointer'
            }}
            onClick={handleMainTextClick}
          >
            <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
              Under Construction
            </Typography>
            
            <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
              Something amazing is coming soon!
            </Typography>
            
            <Typography variant="body1" paragraph>
              Our team of digital craftsmen are working hard to build this page.
            </Typography>
            
            <Typography variant="body1" paragraph>
              Stay tuned for an innovative experience that will revolutionize how you interact with our platform.
            </Typography>
            
            <Box sx={{ 
              mt: 4,
              p: 2,
              border: '2px dashed',
              borderColor: 'divider',
              borderRadius: 1
            }}>
              <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
                "Creativity is intelligence having fun." — Albert Einstein
              </Typography>
            </Box>

           
          </Box>
        ) : (
          <Box sx={{
            p: 4,
            borderRadius: 2,
            backgroundColor: 'background.paper',
            boxShadow: 3,
            textAlign: 'center'
          }}>
            <Typography variant="h4" gutterBottom>
              🎮 Hub4Food!
            </Typography>
            <Typography variant="h6" gutterBottom>
              Score: {score} | Time: {timeLeft}s
            </Typography>
            
            <Box sx={{
              width: '300px',
              height: '200px',
              backgroundColor: '#f0f0f0',
              borderRadius: '8px',
              position: 'relative',
              margin: '20px auto',
              overflow: 'hidden'
            }}>
              <Button
                onClick={handleEmojiClick}
                sx={{
                  position: 'absolute',
                  left: `${emojiPosition.x}%`,
                  top: `${emojiPosition.y}%`,
                  transform: 'translate(-50%, -50%)',
                  minWidth: '40px',
                  height: '40px',
                  fontSize: '24px',
                  transition: 'all 0.3s'
                }}
              >
                🎯
              </Button>
            </Box>
            
            
          </Box>
        )}
      </Container>
      
      <Footer />
    </Box>
  );
};

export default ComingSoon;